/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { ConsignmentEntry } from './ConsignmentEntry';
import {
    ConsignmentEntryFromJSON,
    ConsignmentEntryFromJSONTyped,
    ConsignmentEntryToJSON,
} from './ConsignmentEntry';
import type { EntryArrivalSlot } from './EntryArrivalSlot';
import {
    EntryArrivalSlotFromJSON,
    EntryArrivalSlotFromJSONTyped,
    EntryArrivalSlotToJSON,
} from './EntryArrivalSlot';
import type { PointOfService } from './PointOfService';
import {
    PointOfServiceFromJSON,
    PointOfServiceFromJSONTyped,
    PointOfServiceToJSON,
} from './PointOfService';

/**
 * Representation of a Consignment
 * @export
 * @interface Consignment
 */
export interface Consignment {
    /**
     * Consignment code
     * @type {string}
     * @memberof Consignment
     */
    code?: string;
    /**
     * Consignment tracking identifier
     * @type {string}
     * @memberof Consignment
     */
    trackingID?: string;
    /**
     * Consignment status
     * @type {string}
     * @memberof Consignment
     */
    status?: string;
    /**
     * Consignment status display
     * @type {string}
     * @memberof Consignment
     */
    statusDisplay?: string;
    /**
     * Consignment status date
     * @type {Date}
     * @memberof Consignment
     */
    statusDate?: Date;
    /**
     * List of consignment entries
     * @type {Array<ConsignmentEntry>}
     * @memberof Consignment
     */
    entries?: Array<ConsignmentEntry>;
    /**
     * 
     * @type {Address}
     * @memberof Consignment
     */
    shippingAddress?: Address;
    /**
     * 
     * @type {PointOfService}
     * @memberof Consignment
     */
    deliveryPointOfService?: PointOfService;
    /**
     * 
     * @type {EntryArrivalSlot}
     * @memberof Consignment
     */
    arrivalSlot?: EntryArrivalSlot;
}

/**
 * Check if a given object implements the Consignment interface.
 */
export function instanceOfConsignment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConsignmentFromJSON(json: any): Consignment {
    return ConsignmentFromJSONTyped(json, false);
}

export function ConsignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Consignment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'trackingID': !exists(json, 'trackingID') ? undefined : json['trackingID'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDisplay': !exists(json, 'statusDisplay') ? undefined : json['statusDisplay'],
        'statusDate': !exists(json, 'statusDate') ? undefined : (new Date(json['statusDate'])),
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(ConsignmentEntryFromJSON)),
        'shippingAddress': !exists(json, 'shippingAddress') ? undefined : AddressFromJSON(json['shippingAddress']),
        'deliveryPointOfService': !exists(json, 'deliveryPointOfService') ? undefined : PointOfServiceFromJSON(json['deliveryPointOfService']),
        'arrivalSlot': !exists(json, 'arrivalSlot') ? undefined : EntryArrivalSlotFromJSON(json['arrivalSlot']),
    };
}

export function ConsignmentToJSON(value?: Consignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'trackingID': value.trackingID,
        'status': value.status,
        'statusDisplay': value.statusDisplay,
        'statusDate': value.statusDate === undefined ? undefined : (value.statusDate.toISOString()),
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(ConsignmentEntryToJSON)),
        'shippingAddress': AddressToJSON(value.shippingAddress),
        'deliveryPointOfService': PointOfServiceToJSON(value.deliveryPointOfService),
        'arrivalSlot': EntryArrivalSlotToJSON(value.arrivalSlot),
    };
}

